import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './MoonPhaseIcon.scss';

const cx = classNames.bind(styles);

const getMoonStyle = (percentageVisible, code, shadow = false) => {
  let zIndex = 20;
  if (!shadow) {
    zIndex = percentageVisible > 50 ? 30 : 10;
  }

  const moonStyle = {
    position: 'absolute',
    minHeight: '30px',
    borderRadius: '50%',
    width: '30px',
    top: '50%',
    transform: 'translateY(-50%)',
    height: '30px',
    left: 0,
    background: shadow ? '#343434' : '#CAD3D5',
    zIndex,
  };

  if (shadow) {
    moonStyle.left =
      code === 'wanc' || code === 'last'
        ? -percentageVisible
        : percentageVisible;
  }

  if (percentageVisible > 10) moonStyle.height = 32;
  if (percentageVisible > 20) moonStyle.height = 35;
  if (percentageVisible > 30) moonStyle.height = 40;
  if (percentageVisible > 40) moonStyle.height = 50;

  if (percentageVisible === 50) moonStyle.height = 100;

  if (percentageVisible > 50) {
    moonStyle.height = 50;

    if (shadow) {
      moonStyle.left = 0;
    } else {
      moonStyle.left = 100 - percentageVisible;

      if (code === 'waxg') {
        moonStyle.left *= -1;
      }
    }
  }

  if (percentageVisible > 60) moonStyle.height = 40;
  if (percentageVisible > 70) moonStyle.height = 35;
  if (percentageVisible > 80) moonStyle.height = 32;
  if (percentageVisible > 90) moonStyle.height = 30;

  // Add units to styles
  if (moonStyle.left !== 0) moonStyle.left = `${moonStyle.left}%`;
  if (moonStyle.height !== 0) moonStyle.height = `${moonStyle.height}px`;

  return moonStyle;
};

const MoonPhaseIcon = (props) => {
  const { percentageVisible, code, hemisphere, className } = props;

  const componentClasses = cx('moon-phase-icon', {
    [`moon-phase-icon--${hemisphere}`]: hemisphere,
    [className]: className,
  });

  return (
    <div className={componentClasses}>
      <div
        className={cx('moon-phase-icon__moon-phase-visible-icon-dark')}
        style={getMoonStyle(percentageVisible, code, true)}
      />
      <div
        className={cx('moon-phase-icon__moon-phase-visible-icon-light')}
        style={getMoonStyle(percentageVisible, code)}
      />
    </div>
  );
};

MoonPhaseIcon.propTypes = {
  iconStyle: PropTypes.shape({}),
  percentageVisible: PropTypes.number.isRequired,
  code: PropTypes.string.isRequired,
  hemisphere: PropTypes.oneOf(['northern', 'southern']),

  /** Extra classes */
  className: PropTypes.string,
};

MoonPhaseIcon.defaultProps = {
  iconStyle: null,
  hemisphere: 'southern',
  className: null,
};

export default MoonPhaseIcon;
